import styled, { css } from "styled-components";

export const Th = styled.th`
  border: 1px solid #e6e6e6;
  padding: 6px 15px;
  color: #999;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
  ${props =>
    css`
      ${props.costomStyles};
    `} ${props => (props.onClick ? "cursor: pointer;" : "")};
`;
Th.displayName = "Th";

export default Th;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Th/Th.js